<div class="password-settings">
  <!-- Blocking Overlay -->
  <div *ngIf="isBlocking" class="blocking-overlay">
    <div class="blocking-content">
      <div class="blocking-spinner"></div>
      <p class="blocking-text">Logging out...</p>
    </div>
  </div>
  
  <form class="password-form" [formGroup]="passwordForm" >
    <div class="form-group">
      <label for="currentPassword"
        >Current Password<span class="required">*</span></label
      >
      <input
        type="password"
        id="currentPassword"
        placeholder="Enter current password"
        class="form-control"
        formControlName="currentPassword"
      />
      <div *ngIf="passwordForm.get('currentPassword')?.touched && passwordForm.get('currentPassword')?.invalid">
        <small class="error-message" *ngIf="passwordForm.get('currentPassword')?.errors?.['required']">Current password is required.</small>
      </div>
     <div class="forgot-password-container">
      <a routerLink="/forgot-password" target="_blank" class="btn btn-tertiary btn-small  p7">Forgot password?</a>
     </div>
    </div>
    <div class="form-row">
      <div class="form-group">
        <label for="newPassword"
          >New Password<span class="required">*</span></label
        >
        <input
          type="password"
          id="newPassword"
          placeholder="Enter new password"
          class="form-control"
          formControlName="newPassword"
        />
        <div *ngIf="passwordForm.get('newPassword')?.touched && passwordForm.get('newPassword')?.invalid">
          <small class="error-message" *ngIf="passwordForm.get('newPassword')?.errors?.['required']">New password is required.</small>
          <small class="error-message" *ngIf="passwordForm.get('newPassword')?.errors?.['minlength']">Password must be at least 8 characters long.</small>
        </div>
      </div>
      <div class="form-group">
        <label for="confirmPassword"
          >Confirm New Password<span class="required">*</span></label
        >
        <input
          type="password"
          id="confirmPassword"
          placeholder="Repeat new password"
          class="form-control"
          formControlName="confirmPassword"
        />
        <div *ngIf="passwordForm.get('confirmPassword')?.touched && passwordForm.get('confirmPassword')?.invalid">
          <small class="error-message" *ngIf="passwordForm.get('confirmPassword')?.errors?.['required']">Confirm password is required.</small>
        </div>
        <div *ngIf="passwordForm.hasError('mismatch') && passwordForm.get('confirmPassword')?.touched">
            <small class="error-message">Passwords do not match.</small>
        </div>
      </div>
    </div>
  </form>
  <div class="form-actions" >
    <!-- <button class="btn btn-secondary btn-medium" (click)="onCancel()">
      Cancel
    </button> -->
    <button
      class="btn btn-primary btn-medium"
      [ngClass]="{'disabled': passwordForm.invalid}"
      [disabled]="passwordForm.invalid"
      (click)="onSubmit()"
    >
      Change Password
    </button>
  </div>
</div>
